export const mockOrders = [
  {
    id: "416715428369401091775725916",
    customer: "Renske Thum",
    email: "Renskethum@gmail.com",
    date: "2026/4/9 17:12:43",
    items: [
      {
        name: "Window & Door Sensor (Newest Model)",
        description: "Compact contact sensor that monitors the open/close status of doors and windows.",
        quantity: 1,
        price: 153.31,
        image: "/img/1012.jpg",
      },
    ],
    total: 153.31,
    status: "Shipped",
    shippingAddress: {
      receiver: "Renske Thum",
      phone: "0620336710",
      address: "Roer 5, GRONINGEN, 9733AD, NL",
    },
    trackingNumber: "3SQMAT527360743",
  },
  {
    id: "418986402179236171775737726",
    customer: "Emmanuel Ugoeze",
    email: "sylvanuschimuanya@gmail.com",
    date: "2026/4/9 20:30:00",
    items: [
      {
        name: "Panic Button (Newest Model)",
        description: "Dedicated Panic Button for Rivergrove Alarm that sends an alert when pressed.",
        quantity: 1,
        price: 154.90,
        image: "/img/1014.jpg",
      },
    ],
    total: 154.90,
    status: "Shipped",
    shippingAddress: {
      receiver: "Emmanuel Ugoeze",
      phone: "0641231098",
      address: "Olympialaan 77, Almere, 1362LH, NL",
    },
    trackingNumber: "3SQMAT529356397",
  },
  {
    id: "416842863919304211775749448",
    customer: "Bodhi Van De Ree",
    email: "vandereebodhi@gmail.com",
    date: "2026/4/9 23:44:34",
    items: [
      {
        name: "Smart Plug",
        description: "Plug‑in Smart Lighting controller that turns standard fixtures into smart lights.",
        quantity: 1,
        price: 69.90,
        image: "/img/1011.jpg",
      },
    ],
    total: 69.90,
    status: "Shipped",
    shippingAddress: {
      receiver: "Bodhi Van De Ree",
      phone: "0627165585",
      address: "Malzwin 2412, Noord-Holland, 1788xl, NL",
    },
    trackingNumber: "3SQMAT462234358",
  },
  {
    id: "415447908626533211775753280",
    customer: "N Ghoniashvili",
    email: "nina-e2002@live.nl",
    date: "2026/4/10 00:48:32",
    items: [
      {
        name: "Floodlight Cam Plus",
        description: "Hardwired outdoor camera with powerful dual floodlights for bright illumination.",
        quantity: 1,
        price: 179.99,
        image: "/img/105.jpg",
      },
    ],
    total: 179.99,
    status: "Shipped",
    shippingAddress: {
      receiver: "N Ghoniashvili",
      phone: "0619923559",
      address: "Snekertrekweg 49A18, Leeuwarden, 8912AA, NL",
    },
    trackingNumber: "3SQMAT572187855",
  },
];